import { WSQueryConfig } from "@ws-react-query";
import { listPayableBulkActionBatches } from "../../services/api/payments/payables";
import { WSServiceError } from "../../utils/serviceHelper";
import { useWSQuery } from "../helpers";
import { QUERY_PAYABLE_BULK_ACTION_BATCHES } from "./keys";

export const useQueryListPayablesBulkActionBatches = (
  request?: Parameters<typeof listPayableBulkActionBatches>[0],
  config?: WSQueryConfig<
    Awaited<ReturnType<typeof listPayableBulkActionBatches>>,
    WSServiceError
  >
) =>
  useWSQuery<
    Awaited<ReturnType<typeof listPayableBulkActionBatches>>,
    WSServiceError
  >(
    [QUERY_PAYABLE_BULK_ACTION_BATCHES, request],
    () => listPayableBulkActionBatches(request),
    config
  );
